export const Consts = () => {
  return {
    terms: () => {
      return {
        text: `# ディーモ for 社労士　利用規約

第１条　定義

本規約において使用する用語の意義は、次の各号に定めるとおりとします。
1. 「本規約」とは、「ディーモ for 社労士利用規約」をいいます。
2. 「本契約」とは、本サービスの利用に関する当社と契約者との間の契約をいいます。
3. 「その他の規程」とは、ガイドライン、ヘルプ、その他の本規約以外の本サービスに関する規程をいいます。
4. 「本サービス」とは、社会保険労務士事務所向けシステム「ディーモ for 社労士」（その理由を問わずサービスの名称又は内容が変更された場合、当該変更後のサービスを含みます。）をいいます。
5. 「当社」とは、TEN合同会社をいいます。
6. 「契約者」とは、当社との間で本契約を締結して本サービスを利用する者をいいます。
7. 「申込者」とは、本契約を締結して本サービスを利用することを希望する者をいいます。
8. 「利用者」とは、本規約に基づき契約者から本サービスの利用を認められた契約者の業務従事者をいいます。
9. 「ユーザ数」とは、本契約において本サービスを利用できる利用者の数をいいます
10. 「登録事項」とは、申込者が本契約の申込みの際に登録する当社所定の情報をいいます。
11. 「ID・パスワード」とは、本サービスを利用するために必要となるID・パスワードをいいます。
12. 「利用環境」とは、ハードウェア、ソフトウェア、インターネット接続回線、セキュリティの確保等、本サービスの利用に必要な環境をいいます（メールサービスも含むものとします。）。
13. 「送信情報」とは、契約者が本サービス上に送信した、テキスト、数値、データ、その他当社又はメールサービス事業者所定の情報（これを元に本サービス上で自動生成された情報や処理結果も含みます。）をいいます。
14. 「知的財産権等」とは、特許権、実用新案権、意匠権、商標権、著作権、不正競争防止法上の権利、その他一切の財産的若しくは人格的権利をいいます。

第２条　適用範囲
1. 本規約は、本契約において当社と契約者とに適用されます。契約者は、本規約の全ての内容に同意した上で、本契約を当社と締結するものとします。
2. 当社は、別途、その他の規程を定める場合があります。その他の規程は、本規約の一部を構成するものとしますが、本規約とその他の規程の内容が異なる場合は、本規約が優先して適用されます。

第３条　本サービスの利用条件
1. 本サービスの詳細な仕様は、当社が別途定めるものとします。また、当社は、本サービスの仕様の改良、追加、削除等の変更を行うことがあり、契約者は、これを予め承諾します。
2. 契約者は、本契約の有効期間内に限り、本契約で認められた範囲で、当社の定める方法に従い、本サービスを利用し、また、本サービスが予定している態様にて、自社の業務従事者を利用者として、これを利用させることができます。契約者は、利用者に対し、本規約を遵守させるものとし、利用者による本サービスの利用が、いかなる場合でも自己の利用とみなされることに同意すると共に、かかる利用について、当社に対し、一切の責任を負うものとします。
3. 当社は、本サービスの遂行を、必要に応じて第三者に委託することができるものとします。
4. 契約者は、自らの責任と費用において、当社所定の利用環境を整備するものとします。
5. 当社は、本サービスを利用することで出力・表示されるデータ・フローが正確であるよう、商業上合理的な範囲内で努力しますが、その正確性について保証は行いません。契約者は、本サービスを利用することで出力・表示されるデータ・フローの内容を必ず事前に確認の上、自己の責任に基づいてこれを利用するものとします。
6. 当社は、次の各号につき、いかなる保証も行うものではありません。さらに、契約者が当社から直接又は間接に、本サービスに関する情報を得た場合であっても、当社は、契約者に対し、本規約において規定されている内容を超えて、いかなる保証も行うものではありません。
   1. 本サービスの利用に起因して利用環境に不具合や障害が生じないこと
   2. 本サービスが正確かつ完全であること
   3. 本サービスが永続的に稼働すること
   4. 本サービスが契約者の特定の目的に適合し、有用であること
   5. 本サービスが契約者に適用のある法令、業界団体の内部規則等に適合すること

第４条　オプションサービス
1. 当社は、契約者から別途委託を受けた場合、契約者による本サービスの導入・活用コンサルティング、拡張サポート、その他本サービスの導入・利用支援のオプションサービスを行うものとします。
2. 前項のオプションサービスの費用、対応日時、対応場所、期間、納期等は、別途定めるものとしますが、その他の契約条件は、本規約に定めるとおりとします。
3. 契約者が第１項のオプションサービスを通じて取得した助言又は情報は、本規約に明示的な定めのない保証を生じさせるものではありません。

第５条　申込み
1. 申込者は、本規約の内容に同意した上で、当社所定の方法により、本契約締結の申込みを行うものとします。申込者は、登録事項が、全て正確であることを保証します。
2. 当社は、当社所定の基準により、申込者の申込みの可否を判断し、申込みを認める場合には、その旨及び当社所定の情報を通知します。当該通知に定める契約開始日より、当該契約者と当社との間に、本契約が成立します。
3. 当社は、申込者が以下のいずれかに該当し又は該当すると当社が判断した場合は、申込者の申込みを認めないことができます。なお、当社は、上記判断に関する理由を開示する義務は負いません。
   1. 当社所定の方法によらずに登録の申込を行った場合
   2. 登録事項の全部又は一部につき、虚偽、誤記又は記載漏れがあった場合
   3. 本規約に違反するおそれがあると当社が判断した場合
   4. 過去に本規約に違反した者又はその関係者であると当社が判断した場合
   5. 法人の代表権を有する者の同意を得ていなかった場合
   6. 本サービスと同種又は類似するサービスを現に提供している場合又は将来提供する予定である場合
   7. その他当社が登録を妥当でないと判断した場合
4. 契約者は、登録事項に変更が生じた場合は、直ちに当社所定の方法により、登録事項の変更の手続きを行うものとします。これを怠ったことによって契約者が損害を被ったとしても、当社は一切責任を負わないものとします。

第６条　ID・パスワードの管理
1. 当社は、本契約開始日までに、当社が別途定める方式により、ID・パスワードの発行を受けるものとします。
2. 契約者は、自己の責任において、ID・パスワードを適切に管理・保管し、また、利用者をして、ID・パスワードを管理・保管させるものとし、これを第三者に開示・利用させたり、貸与、譲渡、売買、担保提供等をしてはならないものとします。
3. 当社は、ログイン時に使用されたID・パスワードが登録されたものと一致することを所定の方法により確認した場合、当該ログインした者を真正な契約者・利用者とみなします。
4. 契約者によるID・パスワードの管理不十分、使用上の過誤、不正使用等によって契約者が損害を被ったとしても、当社は一切責任を負わないものとします。

第７条　利用料金及び支払方法
1. 契約者は、当社に対し、本サービス利用の対価として、本契約に定める利用料金を、本契約に定める支払方法に従って、本契約に定める支払期日までに支払うものとします。なお、銀行振込手数料その他支払に要する費用は、契約者の負担とします。
2. その理由を問わず、本契約の有効期間中に契約者が本サービスの提供を受けられなくなった場合又は受ける必要がなくなった場合でも、当社は利用料金の返還を行うことができません。
3. 契約者が利用料金の支払を遅延した場合、年１４．６％の割合による遅延損害金を当社に支払うものとします。
4. 当社は、本サービスの内容の変更、事業上の理由、法令の制定改廃、経済情勢の変動等によって、利用料金の変更の必要が生じたときは、第１８条に従い、利用料金を変更することができるものとします。

第８条　契約期間・更新・解約
1. 本契約の契約期間には、１ヶ月単位の契約と、１年単位の契約があります。以下、1ヶ月単位の契約を月間プラン、１年単位の契約を年間プランといいます。なお、月間プランにおける初回の契約期間は、契約開始日が属する月の末日までで１ヶ月と算定し、年間プランにおける初回の契約期間は、契約開始日が属する月の翌月１日から起算して１年間で算定します。同一の契約者において、月間プラン又は年間プランが併存することはありません。
2. 月間プランでは、本契約開始日が属する月の１日から起算して1ヶ月間を最低契約期間とし、当該最低契約期間経過後は、本契約の終了希望月の前月末日までに、当社又は契約者のいずれからも、本契約を更新せずに終了させる旨の通知を行わない限り、１ヶ月毎に自動更新されるものとします。
3. 年間プランでは、本契約の契約期間満了月の前月末日までに、当社又は契約者のいずれからも、本契約を更新せずに終了させる旨の通知を行わない限り、１年毎に自動更新されるものとします。
4. 当社及び契約者は、本契約の契約期間満了後に本契約を解約できるものとします。

第９条　ユーザ数
1. 月間プラン及び年間プランでは、当社所定のユーザー数の範囲内であれば、利用料金は同一です。
2. 月間プラン及び年間プランでは、契約者は、本契約の契約期間中、当社所定のユーザー数の範囲内でユーザー数を追加することができます。当社所定のユーザー数を超えるユーザー数の追加を希望する場合はお問い合わせ下さい。当社所定のユーザー数を超えたユーザーに係る利用料金は、追加日の属する月の翌月より発生します（すなわち、追加日の属する月は日割計算せず無料とします。）。
3. 月間プラン及び年間プランでは、契約者は、本契約の契約期間中、いつでもユーザー数を削減することができます。当社所定のユーザー数を超えている場合の、削除したユーザー数に係る利用料金は、削除日の属する月の翌月より消滅します（すなわち、削除日の属する月は日割計算せず有料とします。）。

第１０条　権利帰属
1. 本サービスに関する知的財産権等は、全て当社に帰属します。
2. 本規約に定める本サービスの利用許諾は、本規約に明示的に規定される場合を除き、本サービスに関する当社の知的財産権等に関し、いかなる権利も許諾するものではありません。契約者は、本サービスが予定している利用態様を超えて、本サービスを利用することはできません。
3. 契約者は、本サービスに対して、リバースエンジニアリング、逆コンパイル、又は逆アセンブラ、その他本サービスを解析しようと試みてはならないものとします。

第１１条　送信情報
1. 契約者は、送信情報について、自らが送信することについて適法な権利を有していること及び当社又は第三者の権利を侵害するものではないことを保証します。
2. 契約者は、送信情報に係る知的財産権等を、送信後も引き続き保有します。当社は、契約者に対して本サービスを提供するために必要かつ合理的な範囲に限って、送信情報を利用することができるものとします。
3. 当社は、送信情報について、安全に管理するよう努めますが、本サービスが、本質的に情報の喪失、改変、破壊等の危険が内在するインターネット通信網を利用した電磁的サービスであることに鑑みて、契約者は、送信情報を自らの責任においてバックアップするものとします。当該バックアップを怠ったことによって契約者が被った損害について、当社は、送信情報の復旧を含めて、一切責任を負いません。
4. 当社は、以下のいずれかに該当する場合は、送信情報を削除するものとします。当社は、削除された送信情報について、当該情報の復旧を含めて、一切責任を負いません。
   1. 契約者の同意を得たとき
   2. 裁判所、警察等の公的機関から、法令に基づく正式な要請を受けたとき
   3. 法律に従い削除等の義務を負うとき
   4. 契約者が本規約所定の禁止行為を行ったとき
   5. 契約者又は第三者の生命・身体・その他重要な権利を保護するために必要なとき
   6. その理由を問わず、本契約が終了したとき
   7. 第１４条によって本サービスが変更、中断、終了したとき
5. 当社は、送信情報を保存、監視する義務を負わないものとします。


第１２条　禁止行為

契約者は、本サービスの利用にあたり、以下の各号のいずれかに該当し又は該当すると当社が判断する行為をしてはなりません。
1. 法令に違反する行為
2. 犯罪に関連する行為
3. 公序良俗に反する行為
4. 所属する業界団体の内部規則に違反する行為
5. 当社又は第三者の知的財産権等、プライバシー権、名誉権、信用、肖像権、その他一切の権利又は利益を侵害する行為
6. 本サービスの運営・維持を妨げる行為
7. 本サービスのネットワーク又はシステム等に過度の負担をかける行為
8. 本サービスのネットワークに不正にアクセスする行為
9. 第三者になりすます行為
10. 第三者に本サービスを利用させる行為
11. 違法または不正な方法により取得した送信情報を当社に送信する行為
12. 本サービスにより利用しうる情報を改ざんする行為
13. 利用者が前各号の行為を行うことを看過し又は是正しない行為
14. 前各号の行為を直接又は間接に惹起し又は容易にする行為
15. その他、当社が不適切と判断する行為

第１３条　契約解除等
1. 当社は、契約者が以下の各号のいずれかに該当し又は該当すると当社が判断した場合は、事前に通知することなく、本サービスの全部又は一部の利用の一時停止し又は本契約を解除することができます。なお、当社は、上記判断に関する理由を開示する義務は負いません。
   1. 本規約のいずれかの条項に違反した場合
   2. 第５条第３項各号に該当することが判明した場合
   3. 支払停止若しくは支払不能となり、又は、破産、民事再生手続き開始、会社更生手続開始、特別清算手続開始もしくはこれらに類する手続きの開始の申立てがあった場合
   4. 自ら振出し、もしくは引受けた手形または小切手につき、不渡りの処分を受けた場合
   5. 差押、仮差押、仮処分、強制執行または競売の申立てがあった場合
   6. 租税公課を滞納し、その保全差押を受けた場合
   7. 解散または営業停止状態となった場合
   8. 第３乃至第７号の他、契約者の信用状態に重大な変化が生じたと当社が判断した場合
   9. １２ヶ月以上本サービスの利用がない場合
   10. 当社からの問い合わせに対して、２０日間以上応答がない場合
   11. その他、当社が本サービスの利用を適当でないと判断した場合
2. 契約者は、前項各号のいずれかに該当し、又は、該当すると当社が判断した場合は、当社に対して負っている債務の一切について期限の利益を失い、直ちに当社に対する全ての債務の履行をしなければなりません。
3. 契約者が第１項に基づく本サービスの利用の一時停止の措置を受けている場合であっても、本契約が継続している限り、契約者は利用料金を支払う義務を負うものとします。
4. 当社は、本条に基づき当社が行った行為により契約者に生じた損害について、一切の責任を負いません。

第１４条　本サービスの変更、中断、終了
1. 当社は、事業上の理由、システムの過負荷・不具合・メンテナンス、法令の制定改廃、天災地変、偶発的事故・停電・通信障害・不正アクセス、その他の事由により、本サービスをいつでも変更、中断、終了することができるものとし、これによって契約者に生じたいかなる損害についても、一切責任を負いません。
2. 当社は、前項の変更、中断、終了にあたっては、事前に相当期間をもって予告するよう務めます。ただし、緊急やむを得ない場合は、この限りでありません。

第１５条　紛争処理及び損害賠償
1. 契約者は、本サービスの利用に関連して当社に損害を与えた場合、当社に対し、その損害を賠償するものとします。
2. 契約者が、本サービスに関連して第三者からクレームを受け又は第三者との間で紛争が生じた場合、契約者は、直ちにその内容を当社に通知すると共に、契約者の費用と責任において、当該クレーム又は紛争を処理し、その進捗及び結果を当社に報告するものとします。
3. 当社が、契約者による本サービスの利用に関連して第三者からクレームを受け又は第三者との間で紛争が生じた場合、契約者は、契約者の費用と責任において、当該クレーム又は紛争を処理し、その進捗及び結果を当社に報告すると共に、当社が支払いを余儀なくされた金額その他の損害を賠償するものとします。
4. 当社は、本サービスの提供に際して、自己の故意又は重過失により契約者に損害を与えた場合についてのみこれを賠償するものとします。本規約における当社の各免責規定は、当社に故意又は重過失が存する場合には適用しません。
5. 当社が契約者に対して損害賠償義務を負う場合（前項の場合又は法律の適用による場合等）、賠償すべき損害の範囲は、契約者に現実に発生した通常の損害に限る（逸失利益を含む特別の損害は含まない。）ものとし、賠償すべき損害の額は、当該損害発生時までに契約者が当社に現実に支払った利用料金の直近１年間（契約期間が１年間に満たない場合は、当該契約期間）の総額を限度とします。なお、本条は、債務不履行、原状回復義務、不当利得、不法行為その他請求原因を問わず、全ての損害賠償等に適用されるものとします。
6. 前項に拘らず、契約者の損害が、当社による本サービスの提供の全部又は一部が停止したことにより（以下「提供停止」といいます。）発生した場合は、提供停止の状態が発生した時点から起算して４８時間以上その状態が継続したときに限り、翌月の利用料金から、提供停止に係る時間を時間割で計算（６０分未満の端数は切り捨てとします。）した金額を控除することで、前項の賠償に代えるものとします。

第１６条　秘密保持
1. 本条において「開示者」とは、本契約の当事者のうち、秘密情報を開示した者をいい、「受領者」とは、秘密情報を受領した者をいい、「秘密情報」とは、開示者の技術、営業、業務、財務、組織、その他の事項に関する全ての情報の内、情報が提供される媒体（書面、光ディスク、ＵＳＢメモリ及びＣＤ等を含むが、これらに限らないものといます。以下同じ。）又は情報を含む電磁的データ（電子メール、電子ファイルの送信又はアップロード等により開示される場合の電子メール及び電子ファイルを含むが、これらに限られないものとします。以下同じ。）に秘密である旨が明示されている情報をいいます。また、情報が口頭若しくは視覚的方法により開示される場合は、開示時点で秘密である旨が口頭又は視覚的方法により明示され、かつ当該開示の日から１０日以内に、秘密であることが書面又は電子的手段で通知された情報をいいます。ただし、以下のいずれかに該当する情報は、秘密情報には該当しません。
   1. 開示された時点で公知である情報
   2. 開示された後に受領者の責めに帰すべき事由なく公知となった情報
   3. 開示される以前に受領者が正当に保持していた情報
   4. 秘密情報を使用することなく受領者が独自に取得した情報
   5. 受領者が権利を有する第三者から適法に取得した情報
   6. 開示者から秘密保持の必要なき旨書面で確認された情報
2. 受領者は、善良なる管理者の注意義務をもって、受領した秘密情報の取扱及び保管を行うものとします。
3. 受領者は、本契約以外の目的で秘密情報を使用してはならないものとします。
4. 受領者は、本契約のために客観的かつ合理的に必要な範囲に限り、秘密情報の複製を行うことができます。
5. 受領者は、秘密情報を流出させてはならず、また、開示者の事前の書面による承諾なしに、秘密情報を第三者に開示してはならないものとします。ただし、以下の各号に定める者に限り開示することができます。
   1. 本契約のために必要最小限の自己の役員及び従業員（ただし、本サービスのために客観的かつ合理的に必要な範囲の秘密情報に限ります。）
   2. 弁護士、公認会計士等の法律上の守秘義務を負う専門家
   3. 開示者が事前に書面により承諾した第三者（ただし、当該第三者が本契約における受領者の義務と同等の義務を課すことを条件とします。）
6. 受領者に対する秘密情報の開示は、開示者による当該秘密情報に関する権利の譲渡又は実施の許諾とはみなされません。
7. 受領者は、開示者から要求があった場合又は本契約が終了した場合には、開示者の指示に従い、開示者から受領した全ての秘密情報を、速やかに開示者に返還又は抹消するものとします。
8. 受領者は、万一開示を受けた秘密情報が流出した場合には、直ちに開示者にその詳細を報告し、流出の拡大を防止するために客観的に合理的な措置をとるものとします。当該措置に要する合理的な費用は、受領者の負担とします。ただし、開示者の責めに帰すべき事由による場合は、この限りではありません。
9. 受領者は、司法機関又は行政機関等から秘密情報の開示を求められたときは、速やかに、その事実を開示者に通知し、開示者から要請がある場合には、その開示範囲を狭めるための努力を尽くした後、秘密情報を開示することができます。開示者が法的救済を求めるときは、合理的範囲内で開示者に協力するものとします。

第１７条　個人情報の取扱い

当社は、個人情報を、当社所定の「プライバシーポリシー」に基づき、適切に取り扱うものとします。

第１８条　本規約の変更
1. 当社は、以下のいずれかの場合に、本規約をいつでも任意に変更することができます。
   1. 本規約の変更が、契約者の一般の利益に適合するとき
   2. 本規約の変更が、本契約を締結した目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき
2. 当社は、前項による本規約の変更にあたり、本規約の変更の効力発生日の２週間前までに、変更する規定の内容及び変更の効力発生日を、当社が運営するウェブサイト上に掲載又は本サービスで表示する方法により、これを周知します。
3. 契約者が本規約の変更を同意しない場合、第８条（契約期間・更新・解約）の定めに従い、本契約を解約するものとします。契約者が、変更の効力発生日までに本契約を解約しない場合、本規約の変更に同意したものとみなします。

第１９条　連絡
1. 当社から契約者への連絡は、書面の送付、電子メールの送信、または本サービスへの掲載等、当社が適当と判断する手段によって行います。当該連絡が、電子メールの送信又は本サービスへの掲載によって行われる場合は、インターネット上に配信された時点で契約者に到達したものとします。
2. 契約者から当社への連絡は、当社所定の問合せフォーム宛に行うものとします。当社は、問合せフォーム以外からの問い合わせについては、対応する義務を負いません。

第２０条　反社会的勢力との関係排除
1. 本条において「反社会的勢力」とは、次の各号のいずれかに該当する者をいいます。
   1. 暴力団及びその関係団体又はその構成員
   2. 暴力、威力又は詐欺的手法を駆使して経済的利益を追求する団体又は個人
   3. その他、前各号の該当者に準ずる者
2. 契約者及び当社は、次の各号に定める内容について、表明し、保証するものとします。
   1. 自らが反社会的勢力に該当せず、かつ将来に渡っても該当しないこと
   2. 自らが反社会的勢力と不適当な関係を有さず、かつ将来に渡っても不適当な関係を有しないこと
3. 契約者及び当社は、相手方が前項に違反した場合、相手方に対して、催告なくして、本契約の全部又は一部を解除することができます。
4. 契約者又は当社が第２項に違反した場合、契約者又は当社は、相手方に対して負っている債務の一切について期限の利益を失い、直ちに相手方に対する全ての債務の履行をしなければなりません。
5. 契約者及び当社は、本条に基づき自己が行った行為により相手方に生じた損害について、一切責任を負わないものとします。

第２１条　契約上の地位の譲渡等
1. 契約者は、当社の事前の書面による承諾なく、本契約上の地位又は本サービスに基づく権利義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできないこととします。
2. 当社は、本サービスに係る事業を第三者に譲渡（通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。）した場合には、当該事業譲渡に伴い、本契約上の地位又は本サービスに基づく権利義務並びに登録事項、送信情報、個人情報、その他の情報を当該事業譲渡の譲受人に譲渡することができるものとし、契約者は、かかる譲渡に予め同意します。

第２２条　完全合意

本規約は、本契約に係る当事者間の完全な合意を構成し、本契約の締結以前に当事者間でなされた本契約に関連する書面、口頭、その他いかなる方法による合意も、本規約に取って代わられます。

第２３条　分離可能性

本規約の規定の一部が、法令又は裁判所により違法、無効又は不能であるとされた場合においても、当該規定のその他の部分及び本規約のその他の規定は有効に存続し、また、違法、無効又は不能であるとされた部分については、当該部分の趣旨に最も近い有効な規定を無効な部分と置き換えて適用し、若しくは当該部分の趣旨に最も近い有効な規定となるよう合理的な解釈を加えて適用します。

第２４条　準拠法

本規約の準拠法は、日本法とします。

第２５条　管轄

本サービスに関連して契約者と当社の間で紛争が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。

以上

２０２２年１０月１日　制定

２０２５年９月１日　　改訂`,
        revision: 1,
      }
    },
  }
}

// 業種のリスト
export const industries = [
  '農業、林業',
  '漁業',
  '鉱業、採石業、砂利採取業',
  '建設業',
  '製造業',
  '電気・ガス・熱供給・水道業',
  '情報通信業',
  '運輸業、郵便業、倉庫業',
  '卸売業、小売業',
  '金融業、保険業',
  '不動産業、物品賃貸業',
  '学術研究、専門・技術サービス業、広告業',
  '宿泊業、飲食サービス業',
  '生活関連サービス業、娯楽業',
  '教育、学習支援業',
  '医療、福祉、介護',
  '複合サービス事業（郵便局，協同組合）',
  'その他サービス業（廃棄物処理、自動車整備、機械等修理、職業紹介、労働者派遣、政治・経済・文化団体、宗教、外国公務等）',
  '国家公務、地方公務',
  '分類不能の産業',
]
